import Vue from "@/plugins"
import { ActionTree, GetterTree, Module, MutationTree } from "vuex"
import { Country } from "@/models"
import { GET_COUNTRY_LIST, GET_JWT_TOKEN } from "@/store/types/getters"
import { LOAD_COUNTRY_LIST } from "@/store/types/mutations"
import { fetchCountryList } from "@/store/types/actions"
import { isEmpty, isArrayHasLength } from "@/utils/validate"
import { AxiosResponse, AxiosError } from "axios"
import { notifyRequestError } from "@/utils/notify"

export interface State {
    countries: Country[]
}

const namespaced = true

const state: State = {
    countries: [],
}

const getters: GetterTree<State, any> = {
    [GET_COUNTRY_LIST](state: State): Country[] {
        return state.countries
    },
}

const mutations: MutationTree<State> = {
    [LOAD_COUNTRY_LIST](state: State, paylod: Country[]): void {
        state.countries = paylod
    },
}

const actions: ActionTree<State, any> = {
    [fetchCountryList]({ state, rootGetters, commit }): void {
        if (isEmpty(rootGetters[GET_JWT_TOKEN])) {
            return
        }

        if (isArrayHasLength(state.countries)) {
            return
        }

        Vue.prototype
            .$api({
                method: "GET",
                url: "/api/v1/countries",
                headers: {
                    Authorization: "Bearer " + rootGetters[GET_JWT_TOKEN],
                },
            })
            .then((resp: AxiosResponse<Country[]>) => {
                commit(LOAD_COUNTRY_LIST, resp.data)
            })
            .catch((err: AxiosError) => {
                notifyRequestError(err, "Faied to fetch countries")
            })
    },
}

const module: Module<State, any> = {
    namespaced,
    state,
    getters,
    mutations,
    actions,
}

export default module
